import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/purchasing-power-calculator',
  component: () => import('../../routes/PurchasingPowerCalculator.svelte'),
  card: {
    id: 'purchasing-power-calculator',
    title: 'Purchasing Power',
    description:
      'See how inflation erodes the value of money over time. Compare what a dollar amount in the past is worth today, or what your savings will be worth in the future.',
    icon: 'trending_down',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/purchasing-power-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Purchasing Power Calculator – Inflation Impact on Your Money',
    description:
      'Free purchasing power calculator. See how inflation affects what your money is worth over time. Convert historical prices to today\'s dollars or estimate future costs. Based on compound inflation formula.',
  },
};

export default meta;
